/* eslint-disable */
import Vue from 'vue/dist/vue.esm.js';
/* eslint-enable */
import '@badger/cookie-policy';
import '@badger/cookie-policy/lib/index.css';

export default Vue;
